import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";

const createLessonVote = async (lessonUuid: string): Promise<ApiResponse> => {
  const params = new URLSearchParams();
  params.append("lessonUuid", lessonUuid);

  return await httpClient.post(`/apis/lesson/vote/create?${params}`);
};

const deleteLessonVote = async (lessonUuid: string): Promise<ApiResponse> => {
  const params = new URLSearchParams();
  params.append("lessonUuid", lessonUuid);

  return await httpClient.post(`/apis/lesson/vote/delete?${params}`);
};

const checkHasLessonVote = async (lessonUuid: string): Promise<ApiResponse<boolean>> => {
  return await httpClient.get(`/apis/lesson/vote/has-vote`, {
    params: {
      lessonUuid: lessonUuid,
    },
  });
};

const checkHasLessonVotes = async (
  lessonUuids: string[],
): Promise<ApiResponse<Record<string, boolean>>> => {
  return await httpClient.get(`/apis/lesson/vote/has-votes`, {
    params: {
      lessonUuids: lessonUuids,
    },
  });
};

export default {
  createLessonVote,
  deleteLessonVote,
  checkHasLessonVote,
  checkHasLessonVotes,
};
